import Ajax from "Utils/ajax";
export const getTrainerRegistration = (data) => Ajax.post('LFC/getTrainerRegistration',data); 
export const removeRow = (data) => Ajax.post('LFC/removeTipOfTheDay',data); 
export const updateTrainerForm = (data) => Ajax.post('LFC/addUpdateTrainerRegestration',data); 
export const profilePic = (data) => Ajax.post('LFC/profilePic',data); 
export const resumeUploads = (data) => Ajax.post('LFC/resumeUploads',data); 